import { render, staticRenderFns } from "./Oss.vue?vue&type=template&id=7efe11d6&scoped=true&"
import script from "./Oss.vue?vue&type=script&lang=js&"
export * from "./Oss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe11d6",
  null
  
)

component.options.__file = "Oss.vue"
export default component.exports